module.exports = __webpack_public_path__ + "6500c7f1c54cbbfafdfa4ce4ddf87186.png";